module.exports = __webpack_public_path__ + "static/media/image_24.362190e4.png";